export default __webpack_public_path__ + "static/media/whisle-white.f32604cc.svg";